import { Dialog, DialogContent } from "@mui/material";
import React, { useContext } from "react";
import FileUpload from "./FileUpload";
import { FileUploadContext } from "../features/appointments/context/ToggleFileUpload";
import usePrimaryColor from "../hooks/usePrimaryColor";
import FileUploadStepper from './form/fileUpload/FileUploadStepper';
import { useTranslation } from "react-i18next";
import useUser from "../hooks/useUser";
import { GlobalDataContext } from "../contexts/GlobalData";
import { ADD_DOCUMENTS } from "../enums/PermissionTitles";

export default function AttachFileDialog({
  endpoint = null,
  title = "UploadFile",
  asButton = false,
}) {
  const { t } = useTranslation();
  const { roles } = useUser();
  const [openDialog, setOpenDialog] = React.useState(false);
  const { isPermissionAllowed } = useContext(GlobalDataContext);
  const canUploadFiles = isPermissionAllowed(ADD_DOCUMENTS);
  const context = React.useContext(FileUploadContext);
  const color = usePrimaryColor();

  function handleOpenDialog() {
    if (!context.getIsOpen()) {
      context.toggleIsOpen();
    }
    setOpenDialog(true);
  }

  function handleCloseDialog() {
    setOpenDialog(false);
    if (context.getIsOpen()) {
      context.toggleIsOpen();
    }
  }

  function getShowForm() {
    return context.getIsOpen() && openDialog;
  }

  if (roles.user || !canUploadFiles) {
    return null;
  }

  return (
      <>
   {/*
   //old file upload keeping this here just in case if anyone needs to look at the old logic.
      <IconButton
        title={t(title)}
        sx={{ bgcolor: color, color: "white" }}
        onClick={() => handleOpenDialog()}
      >
        <AttachFile />
      </IconButton> */}
      <FileUploadStepper endpoint={endpoint} asButton={asButton}/>
      <Dialog
        open={getShowForm()}
        onClose={() => handleCloseDialog()}
        fullWidth={true}
        maxWidth={"lg"}
      >
        <DialogContent>
          <FileUpload
            endpoint={endpoint}
            numberOfFileLimist={20}
            handleClose={handleCloseDialog}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}
